import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { NavLink, Redirect } from "react-router-dom";
import auth from "../../providers/Auth.Provider";
import { useMutation } from "@apollo/react-hooks";

// CSS File for login
import { appName } from "../../app.json";
import "./login.css";
import { Staff as StaffQuery } from "../../queries/staff.query";
import LoadingSpinner from "../../partials/loading";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";

function Login(props) {
  const [Login, { loading }] = useMutation(StaffQuery.MUTATION.LOGIN, {
    errorPolicy: "all",
    onCompleted: async (data) => {
      // update authentication provider
      const { doc, token } = data.Login;
      await auth.authProvider.Login(doc, token);
      const { from } = props.location.state || {
        from: { pathname: "/home/clinical-note/ward-summary" },
      };
      props.history.push(from.pathname);
    },
    onError: (e) => toast.error(CleanMessage(e.message)),
  });
  // email address
  let usernameRef = React.createRef();
  // staff password
  let passwordRef = React.createRef();

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (!loading) {
      const u = usernameRef.current.value;
      const p = passwordRef.current.value;
      Login({
        variables: { email: u, password: p },
      });
    }
  };

  // check if staff is logged in
  if (auth.authProvider.GetToken()) {
    const { from } = props.location.state || {
      from: { pathname: "/home/clinical-note/ward-summary" },
    };
    return <Redirect to={from} />;
  }

  return (
    <div className="">
      <Helmet>
        <title>Login | {appName}</title>

        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css"
        ></link>
        <link rel="stylesheet" href="./main/css/extra_pages.css"></link>
      </Helmet>

      <div className="login-container">
        <div className="logo-left">clinicalspec</div>
        <div className="row justify-content-center">
          <div className="wrap-login100" style={{ margin: "100px 0 10px 0" }}>
            <form
              className="login100-form validate-form"
              onSubmit={(e) => HandleSubmit(e)}
            >
              <span className="login100-form-logo">
                <img
                  alt="logo"
                  className="no-scale"
                  src="/assets/img/logo.jpeg"
                />
              </span>
              <p className="text-center txt-small-heading">Login Form</p>
              <div
                className="wrap-input100 validate-input"
                data-validate="Enter username"
              >
                <input
                  className="input100"
                  type="text"
                  ref={usernameRef}
                  placeholder="Username / email"
                />
                <span
                  className="focus-input100"
                  data-placeholder="&#xf207;"
                ></span>
              </div>
              <div
                className="wrap-input100 validate-input"
                data-validate="Enter password"
              >
                <input
                  className="input100"
                  ref={passwordRef}
                  type="password"
                  placeholder="Password"
                />
                <span
                  className="focus-input100"
                  data-placeholder="&#xf191;"
                ></span>
              </div>
              <div
                className=""
                style={{ marginTop: "-20px", marginBottom: "10px" }}
              >
                <NavLink className="text1" to="reset-password">
                  Forgot Password? <i className="fa fa-arrow-right"></i>
                </NavLink>
              </div>

              <div className="container-login100-form-btn">
                <button
                  className="login100-form-btn mt-3"
                  style={{ backgroundColor: "gray" }}
                >
                  {loading ? (
                    "Logging in .."
                  ) : (
                    <Fragment>
                      Login <i className="fa fa-sign-in-alt"></i>
                    </Fragment>
                  )}
                </button>
              </div>

              <div className="text-center mt-2">
                <LoadingSpinner loading={loading} />
              </div>
            </form>
          </div>
        </div>
        <div
          className="col-12"
          style={{ color: "white", fontSize: "16px", marginTop: "20px" }}
        >
          <center>Your Technology, Your Healthcare</center>
        </div>
        <div className="col-12">
          <center>
            <p className="footer-info">
              Powered by Infospec © {new Date().getFullYear()}
            </p>
          </center>
        </div>
      </div>
    </div>
  );
}

export default Login;
